<template>
  <div v-if="verticalActionDots">
    <v-menu offsetY>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="action-buttons"
          color="primary"
          fab
          xSmall
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>
            mdi-dots-vertical
          </v-icon>
        </v-btn>
      </template>
      <v-list v-if="actionWithLabel">
        <v-list-item
          v-for="(action,idx) in filteredItemActions"
          :key="idx"
          @click.prevent.stop="$emit('iconAction', action.action)"
        >
          <v-list-item-content>
            <v-list-item-title>
              <v-icon v-text="action.icon" />
              {{ action.label }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list v-else>
        <v-list-item
          v-for="(action,idx) in itemActions"
          :key="idx"
          :disabled="action.isEnable"
          @click.prevent.stop="$emit('iconAction', action)"
        >
          <template
            v-if="action.conditionField ? action.conditionField !== item.status : true"
          >
            <div v-if="isCustomIcon">
              <!-- Custom icon with color -->
              <v-list-item-content v-if="action.name">
                <v-list-item-title
                  :style="`display: flex; align-items: center; ${action.iconAndTextColor ? `color:${action.iconAndTextColor}` : ''}`"
                >
                  <v-icon
                    :disabled="action.isEnable"
                    :style="` ${action.iconAndTextColor ? `color:${action.iconAndTextColor}` : ''}`"
                    v-text="action.icon"
                  />
                  <span>{{ action.name }}</span>
                </v-list-item-title>
              </v-list-item-content>
            </div>
            <div v-else>
              <!-- end Custom icon with color -->
              <v-list-item-content>
                <v-list-item-title>
                  <v-icon
                    :style="` ${action.iconAndTextColor ? `color:${action.iconAndTextColor}` : ''}`"
                    v-text="action.icon"
                  />
                  {{ action.name }}
                </v-list-item-title>
              </v-list-item-content>
            </div>
          </template>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
  <div v-else>
    <v-icon
      v-for="(action,idx) in itemActions"
      :key="idx"
      class="mr-2"
      @click.prevent.stop="$emit('iconAction', action)"
    >
      {{ action }}
    </v-icon>
  </div>
</template>

<script>
export default {
    props: {
        itemActions: {
            type: Array,
            default: () => [],
        },
        verticalActionDots: {
            type: Boolean,
            default: true,
        },
        actionWithLabel: {
            type: Boolean,
            default: false,
        },
        isCustomIcon: {
            type: Boolean,
            default: false,
        },
        item: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        filteredItemActions() {
            return this.itemActions.filter(action => (action.condition ? action.condition : true));
        },
    },
};
</script>
